import UniversalCookies from 'universal-cookie';
import { v4 as uuidv4 } from 'uuid';

const clientCookieStore = new UniversalCookies();

/**
 * Get Snowplow visitor ID from the _spvid_id cookie (if it exists)
 *
 * @param reqCookieHeader - Pass req.headers.cookie for server-side, omit for client-side
 * @returns The Snowplow visitor ID or undefined if cookie doesn't exist
 */
export function getSpVisitorId(reqCookieHeader?: string): string | undefined {
  const cookieStore = reqCookieHeader ? new UniversalCookies(reqCookieHeader) : clientCookieStore;

  // Snowplow cookie name pattern: _spvid_id.<site_hash>
  const allCookies = cookieStore.getAll();

  const snowplowCookieName = Object.keys(allCookies).find((name) => name.startsWith('_spvid_id'));

  if (!snowplowCookieName) {
    return undefined;
  }

  const cookieValue = allCookies[snowplowCookieName];

  if (!cookieValue || typeof cookieValue !== 'string') {
    return undefined;
  }

  // Extract visitor ID (first part before the first dot)
  const visitorId = cookieValue.split('.')[0];

  return visitorId || undefined;
}

/**
 * Get device ID for session binding
 * Uses Snowplow visitor ID if available, otherwise returns ephemeral UUID.
 *
 * @param reqCookieHeader - Pass req.headers.cookie for server-side, omit for client-side
 * @returns Device ID (always returns a value)
 */
export function getDeviceId(reqCookieHeader?: string): string {
  const spVisitorId = getSpVisitorId(reqCookieHeader);

  if (spVisitorId) {
    return spVisitorId;
  }
  console.log('No Snowplow visitor ID found, generating ephemeral UUID');

  return uuidv4();
}
